import { Routes } from '@angular/router';
import { DeviceHistoryComponent } from '../../@theme/components/device-history/device-history.component';
import { LocationsUpdateComponent } from '../../@theme/components/locations-update/locations-update.component';
import { WebpageComponent } from '../../@theme/components/Webpage/webpage.component';
import { WebpagemanagerComponent } from '../../@theme/components/webpagemanager/webpagemanager.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { LocationsExceptionComponent } from '../../@theme/components/locations-exception/locations-exception.component';
import { CrmBoardComponent } from './crm/crm-board/crm-board.component';
import { CrmStartComponent } from './crm/crm-start/crm-start.component';
import { CrmSearchComponent } from './crm/crm-search/crm-search.component';
import { CrmRoutesComponent } from './crm/crm-routes/crm-routes.component';
import { CrmCreateShipmentComponent } from './crm/crm-create-shipment/crm-create-shipment.component';

export const AuthRoutes: Routes = [
  { path: '', component: DashboardComponent, pathMatch: 'full' },
  {
    path: 'dashboard',
    component: DashboardComponent
  },
  {
    path: 'crm',
    component: CrmBoardComponent
  },
  {
    path: 'crm/search',
    component: CrmSearchComponent
  },
  {
    path: 'crm/start',
    component: CrmStartComponent
  },
  {
    path: 'crm/routes',
    component: CrmRoutesComponent
  },
  {
    path: 'crm/create',
    component: CrmCreateShipmentComponent
  },
  {
    path: 'location',
    component: LocationsUpdateComponent
  },
  {
    path: 'location/admin',
    component: LocationsUpdateComponent
  },
  {
    path: 'locationException',
    component: LocationsExceptionComponent
  },
  { path: 'deviceHistory', component: DeviceHistoryComponent },
  { path: 'webpages', component: WebpageComponent },
  { path: 'webpageManager', component: WebpagemanagerComponent },
  {
    path: 'webpageManager/:WebPageID',
    component: WebpagemanagerComponent
  }
];
